import { Icon } from '@chakra-ui/react'
import { faRightToBracket } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useImpersonate } from 'BrokerTsLib/src/hooks/useAccount'
import { useGetUser } from 'BrokerTsLib/src/hooks/useUser'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { HeaderButton, Loading } from '@/components'
import { UserDetail } from '@/containers/user/UserDetail'
import { UserHeader } from '@/containers/user/UserHeader'
import { useAuth } from '@/context/AuthContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { Edit } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

export const UserDetailPage = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { userId: userIdStr } = useParams()
  const userId = userIdStr!

  const { data, isLoading } = useGetUser(userId)

  const { userName } = data?.data || {}

  const { impresonate, isLoading: isImpersonating } = useImpersonate()
  const impersonate = () => userName ? impresonate(userName) : Promise.resolve()

  const breadcrumbs = useMemo(() => {
    const items = []

    items.push({
      to: `/organization/${data?.data.organizationUnitId}`,
      label: data?.data.organizationUnitName ?? 'Organizace',
      current: !user?.allowDisplayOrganization,
    })

    items.push({
      to: '/profile',
      label: data?.data
        ? data.data.firstName ? `${data.data.firstName} ${data.data.lastName}` : data.data.userName
        : 'Uživatel',
      current: true,
    })

    return items
  }, [user, data])

  return (
    <SidebarProvider>
      <PageWrapper
        header={
          <>
            <Breadcrumbs items={breadcrumbs} />
            <UserHeader user={data?.data} isLoading={isLoading}>

              {user?.allowEditOrganizationStructure && (
                <>
                  {userId !== user?.id && user.isSupervisor && data?.data.effectivelyValid && (
                    <HeaderButton onClick={impersonate} isLoading={isImpersonating}>
                      <Icon
                        as={FontAwesomeIcon}
                        icon={faRightToBracket}
                        size="lg"
                      />
                      Login as
                    </HeaderButton>
                  )}
                  <HeaderButton
                    onClick={() => navigate(`/user/${data?.data?.userId}/edit`)}
                    variant="solid"
                    colorScheme="primary"
                    _hover={{ bg: 'primary.600' }}
                  >
                    <Edit />
                    Upravit
                  </HeaderButton>
                </>
              )}
            </UserHeader>
          </>
        }
        sidebar={<Sidebar />}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
            alignContent: 'baseline',
          },
        }}
      >
        {isLoading || !data ? <Loading /> : <UserDetail user={data.data} />}
      </PageWrapper>
    </SidebarProvider>
  )
}
